document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-jump-to-accordion]');

  if (!trigger) {
    return;
  }

  event.preventDefault();

  const targetId = trigger.getAttribute('data-jump-to-accordion');
  const target = document.getElementById(targetId);

  if (!target) {
    return;
  }

  if (typeof target.expand === 'function') {
    target.expand();
  }

  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
